// React
import React, { useContext } from "react";
// React
// CSS
import styles from "./LessonCard.module.css";
// CSS
// Models
import { I_UserLessonSubject } from "../../../Models/interfaces";
// Models
// Context
import { UserTokenContext } from "../../../Contexts/userToken";
// Context
// Components
// Components
// Icons
import { BsList} from "react-icons/bs";
// Icons
import { useNavigate } from "react-router-dom";
import {_stringify} from "../../../Utils/_stringify";
import {GoFile} from "react-icons/go";

type LessonCardProps = {
  teacherName: string;
  data: I_UserLessonSubject;
  state: any;
};

const LessonCard: React.FunctionComponent<LessonCardProps> = ({
  teacherName,
  data,
  state,
}) => {
  const userToken = useContext(UserTokenContext);
  const navigate = useNavigate();
  return (
    <div
      className={`${styles.lessonCard} w-full py-2 flex flex-row items-center justify-between pt-4 dark:!text-black`}
    >
      <div
        className={`${styles.outer} flex flex-row items-center justify-center`}
      >
        {/* <FiMonitor className="p-2 ml-2 text-5xl" /> */}
        <GoFile className="ml-1" />
        <div
          className={`${styles.inner} flex flex-col items-start justify-between`}
        >
          <span className=" text-sm w-11/12">{data.title}</span>
        </div>
      </div>
      <button
        className={`${styles.buyButton} p-1 px-4 rounded-xl text-sm text-white flex flex-row-reverse items-center justify-center no-wrap w-4/12 `}

        onClick={() => {
          const SubjectIdStr = _stringify(data.id);
          localStorage.setItem("selectedSubject", SubjectIdStr);
          navigate(`/subject/${state.teacherData.teacher_id}/${data.id}`, {
            state:{
              ...state,
              subjectData: data,subjectName:data.title,teacherName:teacherName
            }
          });
        }}
      >
        مشاهده
        <BsList className="ml-1" />
      </button>
    </div>
  );
};

export default LessonCard;
